import { render } from "./ProxyManager.vue?vue&type=template&id=bfaa1e18&scoped=true"
import script from "./ProxyManager.vue?vue&type=script&lang=js"
export * from "./ProxyManager.vue?vue&type=script&lang=js"

import "./ProxyManager.vue?vue&type=style&index=0&id=bfaa1e18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfaa1e18"]])

export default __exports__